module.exports = __webpack_public_path__ + "img/laboratorio2_9-16_360.1b0c9856.webp";